import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Header } from '@features/header/HeaderProfile';
import { LayoutLoading } from 'src/layouts/LayoutLoading';
import { useAuthStore } from 'src/store/auth';
import { useLayoutProviderData } from 'src/hooks/useLayoutProviderData';

export const ProfileLayout: React.FC = () => {
  const { isAuthenticated, wasAuthenticated } = useAuthStore();

  useLayoutProviderData();

  if (!isAuthenticated) {
    return (
      <Navigate to={wasAuthenticated ? '/login' : '/registration'} replace />
    );
  }

  return (
    <div className="flex min-h-screen flex-col py-3.5 lg:pt-5 pb-6 max-w-[1920px] profile mx-auto max-xl:mt-[60px]">
      <LayoutLoading />
      <Header />
      <main className="flex flex-1 justify-center gap-4 px-4.5">
        <section className="flex flex-1 flex-col w-full">
          <Outlet />
        </section>
      </main>
    </div>
  );
};